// DS: DS6.1 - Button Semantics
import _extends from "@swc/helpers/src/_extends.mjs";
import _object_destructuring_empty from "@swc/helpers/src/_object_destructuring_empty.mjs";
import React from 'react';
import omit from 'lodash/omit';
import { useListItem } from '../../common';
import { setRef } from '../../../../../utils/refHelpers';
import PlainButtonOrLink from '../../../../Buttons/PlainButtonOrLink';
import ListItemContent from '../../legos/ListItemContent';
const ListItemButton = (unfilteredProps)=>{
    const _useListItem = useListItem(unfilteredProps), { contentProps , ref  } = _useListItem, rest = _extends({}, _object_destructuring_empty(_useListItem.rootProps));
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _extends({
        innerRef: (node)=>setRef(ref, node)
    }, omit(rest, 'checked')), /*#__PURE__*/ React.createElement(ListItemContent, _extends({}, contentProps)));
};
ListItemButton.displayName = 'ListItemButton';
export default ListItemButton;
